import axios from 'axios';

const API_BASE_URL = 'http://localhost:9000/api';

const CombosService = {
    async getProductComboGroups(productId, refresh = false) {
        try {
            const url = refresh
                ? `${API_BASE_URL}/products/${productId}/combo-groups?refresh=true`
                : `${API_BASE_URL}/products/${productId}/combo-groups`;
            const response = await axios.get(url, { timeout: 8000 });
            const result = response?.data;
            if (result?.success) {
                return {
                    success: true,
                    has_combos: result.has_combos || false,
                    combo_groups: result.combo_groups || []
                };
            }
            return { success: false, has_combos: false, combo_groups: [] };
        } catch (error) {
            console.error(`CombosService: Error combo-groups producto ${productId}:`, error?.message);
            return { success: false, has_combos: false, combo_groups: [] };
        }
    },

    async getProductSuggestions(productId) {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/products/${productId}/suggestions`,
                { timeout: 5000 }
            );
            const result = response?.data;
            if (result?.success) {
                return {
                    success: true,
                    suggested_products: result.suggested_products || [],
                    has_suggestions: result.has_suggestions || false
                };
            }
            return { success: false, suggested_products: [], has_suggestions: false };
        } catch (error) {
            console.error(`CombosService: Error sugerencias producto ${productId}:`, error?.message);
            return { success: false, suggested_products: [], has_suggestions: false };
        }
    },

    async getProductBanner(productId) {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/products/${productId}/banner`,
                { timeout: 5000 }
            );
            const result = response?.data;
            if (result?.success) {
                return { success: true, banner_base64: result.banner_base64 };
            }
            return { success: false };
        } catch (error) {
            return { success: false };
        }
    }
};

export default CombosService;
